module.exports = __webpack_public_path__ + "static/media/discord-image-failure.9fe0377f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/discord-image-failure.svg
// module id = 360
// module chunks = 29